import { render } from "./PredictEstimateForm.vue?vue&type=template&id=af1f1a70&ts=true"
import script from "./PredictEstimateForm.vue?vue&type=script&lang=ts"
export * from "./PredictEstimateForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__